module.exports = __webpack_public_path__ + "img/galleria-original-1920.66a5d99d.webp";